import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(app-view)/terms-of-service/_client-page.tsx");
